import { getColorAndLabelForPowderyMildewValue } from '@semios/app-platform-common'
import { BadgeCell } from 'App/Map/PanelDetails/SummaryGridTable/BadgeCell/BadgeCell'
import { translate } from 'i18n/i18n'
import React from 'react'

export const PowderyMildewInfectionRiskIndex = ({ value }: { value: number }) => {
  const { value: valueStr, color } = getColorAndLabelForPowderyMildewValue(value)

  return (
    <BadgeCell backgroundColor={color ?? 'transparent'}>
      {valueStr ? translate.phrases.banyanApp(valueStr) : translate.phrases.templates('-')}
    </BadgeCell>
  )
}
